import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'angular2-cookie/core';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor (private router: Router,
        private authService: AuthService,
        private _cookieService: CookieService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.isLoggedIn()) {
            const roles = JSON.parse(this._cookieService.get('roles'));

            for (const expectedRole of next.data.roles) {
                if (expectedRole.toString() === 'PUBLIC') {
                    return true;
                }
                for (const userRole of roles) {
                    if (userRole.role.toString() === expectedRole.toString()) {
                        return true;
                    }
                }
            }

            this.router.navigate(['']);
            return false;
        }
        this.router.navigate(['/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/auth/auth-guard.service.ts